import { TreatmentTypes } from 'consts/treatmentConsts'
import { sortBy } from 'lodash'

const Priorities = {
  Only: 0,
  Both: 1,
  Other: 2
}

const getConditionPriority = ({ conditionTreatmentTypes, treatmentType }) => {
  const hasAligners = conditionTreatmentTypes.includes(TreatmentTypes.Aligners)
  const hasBraces = conditionTreatmentTypes.includes(TreatmentTypes.Braces)

  if (treatmentType === TreatmentTypes.Aligners) {
    if (hasAligners && !hasBraces) return Priorities.Only
    if (hasAligners && hasBraces) return Priorities.Both
    return Priorities.Other
  }

  if (treatmentType === TreatmentTypes.Braces) {
    if (hasBraces && !hasAligners) return Priorities.Only
    if (hasAligners && hasBraces) return Priorities.Both
    return Priorities.Other
  }

  return Priorities.Other
}

/**
 * Splits and sorts conditions into relevant and rest based on treatmentType.
 *
 * @param {Object} params
 * @param {Array<{ treatmentTypes: string[] }>} params.conditions - Conditions array.
 * @param {string} params.treatmentType - Type to prioritize.
 * @returns {{ relevantConditions: Array, rest: Array }}
 */
export const splitAndSortConditionsByTreatmentType = ({ conditions, treatmentType }) => {
  if (![TreatmentTypes.Aligners, TreatmentTypes.Braces].includes(treatmentType)) {
    return { relevantConditions: conditions, rest: [] }
  }

  const relevant = []
  const rest = []

  conditions.forEach(condition => {
    const priority = getConditionPriority({
      conditionTreatmentTypes: condition.treatmentTypes,
      treatmentType
    })

    if (priority === Priorities.Other) {
      rest.push(condition)
    } else {
      relevant.push({ ...condition, _priority: priority })
    }
  })

  // Sort relevant by priority (only → both)
  const sortedRelevant = sortBy(relevant, '_priority').map(c => {
    const { _priority, ...cleaned } = c
    return cleaned
  })

  return {
    relevantConditions: sortedRelevant,
    rest
  }
}
